<template>
  <div class="content-wrapper">
    <!-- Content Header (Page header) -->
    <section class="content-header">
      <h1>
        Facilities
        <small>Facility</small>
      </h1>
      <ol class="breadcrumb">
        <li><a href="#"><i class="fa fa-dashboard"></i> Home</a></li>
        <li>Facilities</li>
      </ol>
    </section>

    <!-- Main content -->
    <section class="content">
      <div class="row">
        <!-- Left col -->
        <section class="col-lg-3 connectedSortable ui-sortable">
          <div class="box box-solid">
            <div v-if="incomplete_loaded_resource" class="overlay">
              <i class="fa fa-refresh fa-spin"></i>
            </div>
            <div class="box-header" style="cursor: move;">
              <i class="fa fa-filter"></i>
              <h3 class="box-title">
                Filter Facilities
              </h3>
            </div>
            <div class="box-body">
              <h3>Drilldown</h3>
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <label>County</label>
                    <select v-model="select_county" class="form-control" style="width: 100%;" tabindex="-1" v-on:change="clearSelectedSubcounty">
                      <option disabled value="">Filter county ....</option>
                      <option v-for="county in counties">{{ county }}</option>
                    </select>
                    <!--<span class="select2 select2-container select2-container&#45;&#45;default select2-container&#45;&#45;below select2-container&#45;&#45;focus" dir="ltr" style="width: 100%;"><span class="selection"><span class="select2-selection select2-selection&#45;&#45;single" role="combobox" aria-haspopup="true" aria-expanded="false" tabindex="0" aria-labelledby="select2-ysx2-container"><span class="select2-selection__rendered" id="select2-ysx2-container" title="Delaware">Delaware</span><span class="select2-selection__arrow" role="presentation"><b role="presentation"></b></span></span></span><span class="dropdown-wrapper" aria-hidden="true"></span></span>-->
                  </div>
                  <!-- /.form-group -->
                  <div class="form-group">
                    <label>Subcounty</label>
                    <select v-model="select_subcounty" :disabled="select_subcounty_disabled" class="form-control" style="width: 100%;" tabindex="-1" v-on:change="clearSelectedWard">
                      <option disabled value="">Filter subcounty ....</option>
                      <option v-for="subcounty in select_subcounties">{{ subcounty }}</option>
                    </select>
                    <!--<span class="select2 select2-container select2-container&#45;&#45;default select2-container&#45;&#45;disabled" dir="ltr" style="width: 100%;"><span class="selection"><span class="select2-selection select2-selection&#45;&#45;single" role="combobox" aria-haspopup="true" aria-expanded="false" tabindex="-1" aria-labelledby="select2-p076-container"><span class="select2-selection__rendered" id="select2-p076-container" title="Alabama">Alabama</span><span class="select2-selection__arrow" role="presentation"><b role="presentation"></b></span></span></span><span class="dropdown-wrapper" aria-hidden="true"></span></span>-->
                  </div>
                  <!-- /.form-group -->
                  <!-- /.form-group -->
                  <div class="form-group">
                    <label>Ward</label>
                    <select v-model="select_ward" :disabled="select_ward_disabled" class="form-control" style="width: 100%;" tabindex="-1">
                      <option disabled value="">Filter ward ....</option>
                      <option v-for="ward in select_wards">{{ ward }}</option>
                    </select>
                    <!--<span class="select2 select2-container select2-container&#45;&#45;default select2-container&#45;&#45;disabled" dir="ltr" style="width: 100%;"><span class="selection"><span class="select2-selection select2-selection&#45;&#45;single" role="combobox" aria-haspopup="true" aria-expanded="false" tabindex="-1" aria-labelledby="select2-p076-container"><span class="select2-selection__rendered" id="select2-p076-container" title="Alabama">Alabama</span><span class="select2-selection__arrow" role="presentation"><b role="presentation"></b></span></span></span><span class="dropdown-wrapper" aria-hidden="true"></span></span>-->
                  </div>
                  <!-- /.form-group -->
                </div>
              </div>
              <div class="row">
                <div class="col-lg-6">
                  <button class="btn btn-info btn-block" v-on:click="clearSelectedAll">Clear</button>
                </div>
                <div class="col-lg-6">
                  <button class="btn btn-primary btn-block" v-on:click="filterFacilities">Filter</button>
                </div>
              </div>
              <hr>
              <h3>Full Search</h3>
              <div class="row">
                <div class="col-md-12">
                  <!-- /.form-group -->
                  <div class="form-group">
                    <label>Subcounty</label>
                    <div class="input-group margin">
                      <select v-model="select2_subcounty" class="form-control" style="width: 100%;" tabindex="-1" v-on:change="filterFullSearchWards">
                        <option disabled value="">Filter subcounty ....</option>
                        <option v-for="subcounty in subcounties">{{ subcounty }}</option>
                      </select>
                      <span class="input-group-btn">
                        <button type="button" class="btn btn-danger btn-flat" v-on:click="clearFilterSubcounties"><i class="fa fa-close"></i></button>
                      <button type="button" class="btn btn-primary btn-flat" v-on:click="filterSubcounties"><i class="fa fa-search"></i></button>
                    </span>
                    </div>
                    <!--<span class="select2 select2-container select2-container&#45;&#45;default select2-container&#45;&#45;disabled" dir="ltr" style="width: 100%;"><span class="selection"><span class="select2-selection select2-selection&#45;&#45;single" role="combobox" aria-haspopup="true" aria-expanded="false" tabindex="-1" aria-labelledby="select2-p076-container"><span class="select2-selection__rendered" id="select2-p076-container" title="Alabama">Alabama</span><span class="select2-selection__arrow" role="presentation"><b role="presentation"></b></span></span></span><span class="dropdown-wrapper" aria-hidden="true"></span></span>-->
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <!-- /.form-group -->
                  <div class="form-group">
                    <label>Ward</label>
                    <div class="input-group margin">
                      <select v-model="select2_ward" class="form-control" style="width: 100%;" tabindex="-1">
                        <option disabled value="">Filter ward ....</option>
                        <option v-for="ward in filteredWards">{{ ward }}</option>
                      </select>
                      <span class="input-group-btn">
                        <button type="button" class="btn btn-danger btn-flat" v-on:click="clearFilterWards"><i class="fa fa-close"></i></button>
                      <button type="button" class="btn btn-primary btn-flat" v-on:click="filterWards"><i class="fa fa-search"></i></button>
                    </span>
                    </div>
                    <!--<span class="select2 select2-container select2-container&#45;&#45;default select2-container&#45;&#45;disabled" dir="ltr" style="width: 100%;"><span class="selection"><span class="select2-selection select2-selection&#45;&#45;single" role="combobox" aria-haspopup="true" aria-expanded="false" tabindex="-1" aria-labelledby="select2-p076-container"><span class="select2-selection__rendered" id="select2-p076-container" title="Alabama">Alabama</span><span class="select2-selection__arrow" role="presentation"><b role="presentation"></b></span></span></span><span class="dropdown-wrapper" aria-hidden="true"></span></span>-->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section class="col-lg-9 connectedSortable ui-sortable">

          <!-- Map box -->
          <div class="box box-solid">
            <div class="box-header ui-sortable-handle" style="cursor: move;">
              <i class="fa fa-map-marker"></i>

              <h3 class="box-title">
                Facilities
              </h3>
            </div>
            <div class="box-body">
              <gmap-map
                :center="center"
                :zoom="7"
                style="width: auto; height: 800px"
              >
                <gmap-polygon :paths="paths"
                              ref="polygon">
                </gmap-polygon>
                <gmap-marker
                  :icon="m.marker"
                  :key="index"
                  v-for="m in markers"
                  :position="m.position"
                  :clickable="true"
                  @click="center=m.position, m.opened = !m.opened"
                >
                  <gmap-info-window :opened="m.opened"><a v-bind:href="'facilities/' + m._id" target="_blank">{{ m.text }}</a></gmap-info-window>
                </gmap-marker>
              </gmap-map>
            </div>
            <!-- /.box-body-->
            <div class="box-footer no-border">
              <div class="row">
                <!-- ./col -->
                <div class="col-md-12">
                  <vue-good-table
                    title="Facilities"
                    :columns="columns"
                    :rows="filtered_facilities"
                    :paginate="true"
                    :lineNumbers="true"
                    :defaultSortBy="{field: 'name', type: 'asc'}"
                    styleClass="table condensed table-bordered table-striped">
                    <template slot="table-row" scope="props">
                      <td><a v-bind:href="'facilities/' + props.row._id" target="_blank">{{ props.row.name }}</a></td>
                      <td><span class="label" v-bind:class="{ 'nivi-unsurveyed': props.row.status === nivi_status[0], 'nivi-inactive': props.row.status === nivi_status[2], 'nivi-incomplete': props.row.status === nivi_status[1], 'nivi-active': props.row.status === nivi_status[3] }">{{ props.row.status }}</span></td>
                      <!--<td>{{ props.row.status }}</td>-->
                      <td>{{props.row.ward}}</td>
                      <!--<td>{{ props.row.heirachy.county }}</td>-->
                    </template>
                  </vue-good-table>
                </div>
              </div>
              <!-- /.row -->
            </div>
          </div>
          <!-- /.box -->
        </section>
        <!-- right col -->
      </div>
    </section>
    <!-- /.content -->
  </div>
</template>

<script>
  import * as VueGoogleMaps from 'vue2-google-maps'
  import VueGoodTable from 'vue-good-table'
  import Vue from 'vue'
  import {
    getNiviFacilities, getNiviLocations, getNiviGeojsons
  }
    from '../../../utils/stats'
  Vue.use(VueGoogleMaps, {
    load: {
      key: 'AIzaSyB6PpVWtGqHvdWGbwlX_VkKvZgrHuhpHWE'
    }
  })
  Vue.use(VueGoodTable)

  export default {
    name: 'app-facilities',
    methods: {
      facilityRecord (ev) {
        this.$router.push({ path: 'facilities/' + ev })
      },
      filterFacilities () {
        if (this.select_ward) {
          //  Search with ward
          console.log('ward selected')
          let facilitiesFiltered = []
          for (let f = 0; f < this.facilities.length; f++) {
            if (this.facilities[f]['ward'] === this.select_ward) {
              facilitiesFiltered.push(this.facilities[f])
            }
          }
          this.pushFacilitiesToMap(facilitiesFiltered)
          this.filtered_facilities = facilitiesFiltered
        } else if (this.select_subcounty) {
        //  Search subcounty
          console.log('subcounty selected')
          this.select_ward = false
          let facilitiesFiltered = []
          let wards = Object.keys(this.locations[this.select_county][this.select_subcounty])
          for (let f = 0; f < this.facilities.length; f++) {
            if (wards.indexOf(this.facilities[f]['ward']) > 0) {
              facilitiesFiltered.push(this.facilities[f])
            }
          }
          this.pushFacilitiesToMap(facilitiesFiltered)
          this.filtered_facilities = facilitiesFiltered
        } else if (this.select_county) {
        //  Search county
          console.log('county selected')
          this.select_subcounty = false
          let c = this.locations[this.select_county]
          let w = []
          let sc = Object.keys(c)
          for (let j = 0; j < sc.length; j++) {
            w.push(...Object.keys(this.locations[this.select_county][[sc[j]]]))
          }
          let facilitiesFiltered = []
          for (let f = 0; f < this.facilities.length; f++) {
            if (w.indexOf(this.facilities[f]['ward']) > 0) {
              facilitiesFiltered.push(this.facilities[f])
            }
          }
          this.pushFacilitiesToMap(facilitiesFiltered)
          this.filtered_facilities = facilitiesFiltered
        }
      },
      filterSubcounties () {
        let counties = Object.keys(this.locations)
        for (let i = 0; i < counties.length; i++) {
          let subcounties = Object.keys(this.locations[counties[i]])
          if (subcounties.indexOf(this.select2_subcounty) > 0) {
            let wards = Object.keys(this.locations[counties[i]][this.select2_subcounty])
            let facilitiesFiltered = []
            for (let f = 0; f < this.facilities.length; f++) {
              if (wards.indexOf(this.facilities[f]['ward']) > 0) {
                facilitiesFiltered.push(this.facilities[f])
              }
            }
            this.pushFacilitiesToMap(facilitiesFiltered)
            this.filtered_facilities = facilitiesFiltered
            break
          }
        }
      },
      filterWards () {
        let facilitiesFiltered = []
        for (let f = 0; f < this.facilities.length; f++) {
          if (this.facilities[f]['ward'] === this.select2_ward) {
            facilitiesFiltered.push(this.facilities[f])
          }
        }
        this.pushFacilitiesToMap(facilitiesFiltered)
        this.filtered_facilities = facilitiesFiltered
      },
      clearSelectedSubcounty () {
        this.select_ward = ''
        this.select_subcounty = ''
        this.select_subcounty_disabled = false
        this.select_subcounties = Object.keys(this.locations[this.select_county]).sort()
      },
      clearSelectedWard () {
        this.select_ward = ''
        this.select_ward_disabled = false
        this.select_wards = Object.keys(this.locations[this.select_county][this.select_subcounty]).sort()
      },
      clearSelectedAll () {
        this.select_county = ''
        this.select_subcounty = ''
        this.select_ward = ''
        this.select_subcounty_disabled = true
        this.select_ward_disabled = true
        this.filtered_facilities = this.facilities
      },
      clearFilterSubcounties () {
        this.select2_subcounty = ''
        this.select2_ward = ''
        this.filteredWards = this.wards
      },
      clearFilterWards () {
        this.select2_ward = ''
        this.filteredWards = this.wards
      },
      pushFacilitiesToMap (facilities) {
        this.markers = []
        for (let i = 0; i < facilities.length; i++) {
          if (facilities[i].gps == null) {
            continue
          }
          let marker = {
            position: {lat: facilities[i].gps.coordinates[1], lng: facilities[i].gps.coordinates[0]},
            text: facilities[i].name,
            opened: false,
            _id: facilities[i]._id
          }
          // 0: 'UNSURVEYED',
          // 1: 'INCOMPLETE',
          // 2: 'INACTIVE',
          // 3: 'ACTIVE'
          if (facilities[i].status === this.nivi_status[0]) {
            marker.marker = this.mapPin
            this.markers.push(marker)
          } else if (facilities[i].status === this.nivi_status[1]) {
            marker.marker = this.mapSquare
            this.markers.push(marker)
          } else if (facilities[i].status === this.nivi_status[2]) {
            marker.marker = this.mapTriangle
            this.markers.push(marker)
          } else if (facilities[i].status === this.nivi_status[3]) {
            marker.marker = this.mapSquareCircle
            this.markers.push(marker)
          }
        }
      },
      cleanFacilities () {
        for (let i = 0; i < this.facilities.length; i++) {
          // 0: 'UNSURVEYED',
          // 1: 'INCOMPLETE',
          // 2: 'INACTIVE',
          // 3: 'ACTIVE'
          if (this.facilities[i].status === 0) {
            this.facilities[i].status = this.nivi_status[this.facilities[i].status]
          } else if (this.facilities[i].status === 1) {
            this.facilities[i].status = this.nivi_status[this.facilities[i].status]
          } else if (this.facilities[i].status === 2) {
            this.facilities[i].status = this.nivi_status[this.facilities[i].status]
          } else if (this.facilities[i].status === 3) {
            this.facilities[i].status = this.nivi_status[this.facilities[i].status]
          }
        }
      },
      filterFullSearchWards () {
        console.log(this.locations)
        let counties = Object.keys(this.locations)
        let county = ''
        for (let i = 0; i < counties.length; i++) {
          let subcounties = Object.keys(this.locations[counties[i]])
          for (let j = 0; j < subcounties.length; j++) {
            if (this.select2_subcounty === subcounties[j]) {
              county = counties[i]
              break
            }
          }
        }
        console.log('subcounty ...' + this.select2_subcounty)
        // let county = this.objectKeyByValue(this.locations, this.select2_subcounty)
        console.log(county)
        this.filteredWards = Object.keys(this.locations[county][this.select2_subcounty]).sort()
      }
    },
    data () {
      return {
        select_county: '',
        select_subcounty: '',
        select_ward: '',
        select_subcounties: '',
        select_wards: '',
        select2_subcounty: '',
        select2_ward: '',
        selected: '',
        incomplete_loaded_resource: true,
        select_subcounty_disabled: true,
        select_ward_disabled: true,
        nivi_status: {
          0: 'UNSURVEYED',
          1: 'INCOMPLETE',
          2: 'INACTIVE',
          3: 'ACTIVE'
        },
        center: {lat: 0.2203904, lng: 38.4046},
        markers: [],
        mapPin: {
          path: 'M0-48c-9.8 0-17.7 7.8-17.7 17.4 0 15.5 17.7 30.6 17.7 30.6s17.7-15.4 17.7-30.6c0-9.6-7.9-17.4-17.7-17.4z',
          fillColor: '#ffa500',
          fillOpacity: 1,
          strokeColor: '',
          strokeWeight: 0,
          scale: 0.2
        },
        mapSquare: {
          path: 'M22-48h-44v43h16l6 5 6-5h16z',
          fillColor: '#008000',
          fillOpacity: 1,
          strokeColor: '',
          strokeWeight: 0,
          scale: 0.2
        },
        mapSquareCircle: {
          path: 'M24-8c0 4.4-3.6 8-8 8h-32c-4.4 0-8-3.6-8-8v-32c0-4.4 3.6-8 8-8h32c4.4 0 8 3.6 8 8v32z',
          fillColor: '#e52c4f',
          fillOpacity: 1,
          strokeColor: '',
          strokeWeight: 0,
          scale: 0.2
        },
        mapTriangle: {
          path: 'M 100 100 L 300 100 L 200 300 z',
          fillColor: '#0000ff',
          fillOpacity: 1,
          strokeColor: '',
          strokeWeight: 0,
          scale: 0.08
        },
        columns: [
          {
            label: 'Facility',
            field: 'name',
            filterable: true,
            html: true
          },
          {
            label: 'Status',
            field: 'status',
            filterable: true
          },
          {
            label: 'Ward',
            field: 'ward',
            filterable: true
          }
        ],
        facilities: [],
        filtered_facilities: [],
        locations: {},
        counties: [],
        subcounties: [],
        wards: [],
        filteredWards: [],
        paths: []
      }
    },
    mounted () {
      getNiviGeojsons().then((response) => {
        let wardGeojsons = response.data.wards
        let countiesGeojsons = response.data.counties
        console.log(wardGeojsons)
        console.log(countiesGeojsons)
        let countiesKeys = Object.keys(countiesGeojsons)
        for (let i = 0; i < countiesKeys.length; i++) {
          // console.log(countiesGeojsons[countiesKeys[i]])
          // console.log(typeof countiesGeojsons[countiesKeys[i]]['coordinates'][0]['lat'])
          this.paths.push(countiesGeojsons[countiesKeys[i]]['coordinates'])
          // let constituencies = countiesGeojsons[countiesKeys[i]]['constituencies']
          // for (let constituency in constituencies) {
          //   this.paths.push(constituencies[constituency]['coordinates'])
          // }
        }
      }).catch(error => {
        console.log(error)
      })
      getNiviLocations().then((response) => {
        let locations = []
        let counties = []
        if (localStorage.getItem('locations')) {
          console.log('Retrieving LOCATIONS from local storage..........')
          this.locations = JSON.parse(localStorage.getItem('locations'))
          locations = this.locations
        } else {
          console.log('Receiving LOCATIONS from api ........')
          this.locations = response.data.locations
          locations = this.locations
          console.log('Saving LOCATIONS to local storage............')
          localStorage.setItem('locations', JSON.stringify(this.locations))
          console.log('LOCATIONS saved to local Storage .............')
        }
        if (localStorage.getItem('counties')) {
          console.log('Retrieving COUNTIES from local storage..........')
          this.counties = JSON.parse(localStorage.getItem('counties'))
          counties = this.counties
        } else {
          console.log('Receiving COUNTIES from api ........')
          this.counties = Object.keys(this.locations).sort()
          counties = this.counties
          console.log('Saving COUNTIES to local storage............')
          localStorage.setItem('counties', JSON.stringify(this.counties))
          console.log('COUNTIES saved to local Storage .............')
        }
        if (localStorage.getItem('subcounties')) {
          console.log('Retrieving SUBCOUNTIES from local storage..........')
          this.subcounties = JSON.parse(localStorage.getItem('subcounties'))
        } else {
          console.log('Receiving SUBCOUNTIES from api ........')
          this.subcounties = (function () {
            let sc = []
            for (let i = 0; i < counties.length; i++) {
              let county = counties[i]
              sc.push(...Object.keys(locations[county]))
            }
            return sc.sort()
          })()
          console.log('Saving SUBCOUNTIES to local storage............')
          localStorage.setItem('subcounties', JSON.stringify(this.subcounties))
          console.log('SUBCOUNTIES saved to local Storage .............')
        }
        if (localStorage.getItem('wards')) {
          console.log('Retrieving WARDS from local storage..........')
          this.wards = JSON.parse(localStorage.getItem('wards'))
          this.filteredWards = this.wards
        } else {
          console.log('Receiving WARDS from api ........')
          this.wards = (function () {
            let w = []
            for (let i = 0; i < counties.length; i++) {
              let c = locations[counties[i]]
              let sc = Object.keys(c)
              for (let j = 0; j < sc.length; j++) {
                w.push(...Object.keys(locations[counties[i]][[sc[j]]]))
              }
            }
            return w.sort()
          })()
          console.log('Saving WARDS to local storage............')
          localStorage.setItem('wards', JSON.stringify(this.wards))
          this.filteredWards = this.wards
          console.log('WARDS saved to local Storage .............')
        }
        this.incomplete_loaded_resource = false
      }).catch(error => {
        console.log(error)
      })
      getNiviFacilities().then((response) => {
        if (localStorage.getItem('facilities')) {
          console.log('Retrieving FACILITIES from local storage.........')
          this.facilities = JSON.parse(localStorage.getItem('facilities'))
        } else {
          console.log('Retreiving FACILITIES from api ........')
          this.facilities = response.data.facilities
          this.facilities = this.facilities.sort()
          this.cleanFacilities()
          console.log('Saving FACILITIES to local storage............')
          localStorage.setItem('facilities', JSON.stringify(this.facilities))
          console.log('FACILITIES saved to local Storage .............')
        }
        this.filtered_facilities = this.facilities
      }).catch(error => {
        console.log(error)
      })
    }
  }
</script>



// WEBPACK FOOTER //
// Facilities.vue?7eb049da